<template>
  <h2>404 Not Found</h2>
</template>

<script setup lang="ts"></script>

<style scoped lang="less"></style>
